<div class="animate-fadeIn flex flex-col gap-6">
  <div class="flex flex-wrap items-center justify-between gap-4">
    <!-- The tab does two jobs; this picks which one is on screen. The switch is
         hidden entirely when no AI provider is configured, so a clinic without
         one sees exactly the catalogue it had before. -->
    <div class="flex justify-start">
      <div *ngIf="showMappingView"
        class="flex items-center gap-1 p-1 bg-white rounded-full border border-slate-200 shadow-sm">
        <button (click)="setView('catalogue')"
          [class.bg-primary]="view === 'catalogue'" [class.text-white]="view === 'catalogue'"
          [class.text-slate-400]="view !== 'catalogue'"
          class="px-4 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none whitespace-nowrap">
          {{ 'DTP_VIEW_CATALOGUE' | translate }}
        </button>
        <button (click)="setView('mapping')"
          [class.bg-primary]="view === 'mapping'" [class.text-white]="view === 'mapping'"
          [class.text-slate-400]="view !== 'mapping'"
          class="px-4 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none whitespace-nowrap flex items-center gap-2">
          {{ 'DTP_VIEW_MAPPING' | translate }}
          <span *ngIf="view !== 'mapping' && mappingTotalCount"
            class="px-1.5 py-0.5 rounded-full bg-slate-100 text-slate-500 text-[8px] leading-none">
            {{ mappingLinkedCount }}/{{ mappingTotalCount }}
          </span>
        </button>
      </div>
    </div>

    <!-- Actions (right) -->
    <div class="flex justify-end">
      <!-- Catalogue import is independent of any AI provider, so unlike the rules
           import above it is NOT gated on Diagnocat credentials. -->
      <app-button *ngIf="canCreate" [label]="'DIAG_IMPORT.BUTTON' | translate" icon="pi pi-file-import"
        variant="ghost" (onClick)="onOpenImportDiagnostics()">
      </app-button>
      <app-button *ngIf="hasDiagnocatCreds && canCreate" [label]="'dtp_bulk_update_rules' | translate" icon="pi pi-upload"
        variant="ghost" (onClick)="onOpenImport()">
      </app-button>
    </div>
  </div>

  <!-- Below md this is a DRILL-DOWN, one column at a time (see paneClass): three
       stacked 720px panels meant 2160px of scrolling, and selecting a diagnosis
       updated a panel a screen and a half below the fold. -->
  <div *ngIf="view === 'catalogue' && mobilePane !== 'diagnostics'"
    class="md:hidden flex items-center gap-2 -mt-2">
    <button (click)="mobileBack()"
      class="flex items-center gap-1.5 text-[10px] font-black uppercase tracking-widest text-slate-500 hover:text-primary transition-colors px-3 py-2 rounded-xl hover:bg-primary/5">
      <i class="pi pi-arrow-left text-[10px]"></i>{{ 'back' | translate }}
    </button>
    <span class="text-[10px] font-bold text-slate-400 truncate min-w-0">
      <ng-container *ngIf="selectedDiagnostic">{{ selectedDiagnostic.name }}</ng-container>
      <ng-container *ngIf="!selectedDiagnostic && treatmentsScope === 'all'">{{ 'DTP_ALL_TREATMENTS' | translate }}</ng-container>
      <ng-container *ngIf="selectedTreatment"> &rsaquo; {{ selectedTreatment.name }}</ng-container>
    </span>
  </div>

  <!-- Height follows the viewport instead of dictating it: a fixed 720px already
       overflowed a 1366x768 laptop. min-h-0 on the children is what lets each
       pane scroll internally rather than stretching the grid row. -->
  <div *ngIf="view === 'catalogue'"
    class="grid grid-cols-1 md:grid-cols-3 grid-rows-[minmax(0,1fr)] gap-6 h-[calc(100vh-17rem)] min-h-[420px]">
    <!-- Diagnostics Column -->
    <div [ngClass]="paneClass('diagnostics')">
      <app-catalogue-pane
        heading="diagnostics_label"
        icon="pi-bookmark"
        [count]="visibleDiagnostics.length"
        [showCount]="true"
        [loading]="loadingDiagnostics"
        [isEmpty]="visibleDiagnostics.length === 0"
        emptyIcon="pi-folder-open"
        emptyMessage="no_items_added"
        [showSearch]="true"
        [(search)]="diagnosticSearch"
        [bodyClass]="diagnosticsView === 'tree' ? 'p-0' : 'p-3'">

        <!-- View switch, expand-all and Add share ONE row: three stacked rows
             left the Add button marooned under a band of empty space. -->
        <div paneActions class="w-full flex items-center justify-between gap-2">
          <div class="flex items-center gap-1.5 min-w-0">
            <div class="flex items-center gap-1 p-1 bg-white rounded-full border border-slate-200 shadow-sm shrink-0">
              <button (click)="setDiagnosticsView('list')"
                [class.bg-primary]="diagnosticsView === 'list'" [class.text-white]="diagnosticsView === 'list'"
                [class.text-slate-400]="diagnosticsView !== 'list'"
                class="px-2.5 py-1 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none flex items-center gap-1.5">
                <i class="pi pi-list text-[9px]"></i>{{ 'DIAG_TREE.VIEW_LIST' | translate }}
              </button>
              <button (click)="setDiagnosticsView('tree')"
                [class.bg-primary]="diagnosticsView === 'tree'" [class.text-white]="diagnosticsView === 'tree'"
                [class.text-slate-400]="diagnosticsView !== 'tree'"
                class="px-2.5 py-1 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none flex items-center gap-1.5">
                <i class="pi pi-sitemap text-[9px]"></i>{{ 'DIAG_TREE.VIEW_TREE' | translate }}
              </button>
            </div>

            <button *ngIf="diagnosticsView === 'tree'" (click)="toggleAllGroups()"
              class="shrink-0 text-[9px] font-black uppercase tracking-widest text-slate-400 hover:text-primary transition-colors px-2 py-1 rounded-lg hover:bg-primary/5 whitespace-nowrap">
              {{ (allGroupsOpen ? 'DIAG_TREE.COLLAPSE_ALL' : 'DIAG_TREE.EXPAND_ALL') | translate }}
            </button>
          </div>

          <app-button *hasPermission="'Configurações:create'" [label]="'add_label' | translate" icon="pi pi-plus"
            size="small" (onClick)="onAdd('diagnostic')"></app-button>
        </div>

        <!-- One catalogue row. Extracted into a template so the tree view can
             reuse it instead of duplicating the links popover and the edit
             affordance - two copies of that markup would drift apart. -->
        <ng-template #diagnosticRow let-item="item" let-tree="tree" let-deep="deep">
            <div (click)="selectDiagnostic(item)"
              class="flex items-center justify-between cursor-pointer transition-all duration-200 group"
              [ngClass]="tree
                ? (deep ? 'pl-12 pr-4 py-3 ' : 'pl-8 pr-4 py-3 ')
                  + 'border-b border-slate-50 '
                  + (selectedDiagnostic?.id === item.id ? 'bg-primary/5' : 'hover:bg-slate-50/70')
                : 'px-5 py-4 rounded-2xl mb-1 border '
                  + (selectedDiagnostic?.id === item.id
                      ? 'bg-primary/5 border-primary/20'
                      : 'border-transparent hover:bg-slate-50')">
              <div class="flex items-center gap-3 min-w-0">
                <div class="rounded-full transition-all shrink-0"
                  [ngClass]="tree ? 'w-1.5 h-1.5' : 'w-2 h-2'"
                  [class.bg-primary]="selectedDiagnostic?.id === item.id"
                  [class.bg-slate-300]="selectedDiagnostic?.id !== item.id"></div>
                <span class="text-sm"
                  [ngClass]="selectedDiagnostic?.id === item.id ? 'font-bold text-primary' : 'font-medium text-slate-700'">{{ item.name }}</span>
                <!-- How many AI entries import as this diagnosis. Deleting it
                     clears those links, so the count must be visible here, and
                     clicking opens which ones so the number is inspectable. -->
                <button *ngIf="linkedProviderCount(item.id)"
                  (click)="$event.stopPropagation(); linksPanel.toggle($event)"
                  [title]="'DTP_LINKED_FROM' | translate"
                  class="flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-primary/5 text-primary text-[9px] font-black hover:bg-primary/15 transition-all">
                  <i class="pi pi-link text-[8px]"></i>{{ linkedProviderCount(item.id) }}
                </button>

                <p-popover #linksPanel [style]="{width: '360px'}" styleClass="shadow-2xl border-0">
                  <div class="p-3 bg-white rounded-xl" (click)="$event.stopPropagation()">
                    <div class="flex items-center justify-between mb-3 pb-2 border-b border-slate-50">
                      <h4 class="text-[11px] font-black text-slate-800 uppercase tracking-widest">
                        {{ 'DTP_LINKED_FROM' | translate }}
                      </h4>
                      <span class="px-2 py-0.5 rounded bg-primary/5 text-primary text-[10px] font-black">
                        {{ linkedProviderCount(item.id) }}
                      </span>
                    </div>
                    <p class="text-[10px] font-bold text-slate-400 mb-2 leading-snug">
                      {{ 'DTP_LINKED_FROM_HINT' | translate: { name: item.name } }}
                    </p>
                    <div class="flex flex-col gap-1 max-h-[240px] overflow-y-auto custom-scrollbar pr-1">
                      <div *ngFor="let entry of linkedProviderEntries(item.id)"
                        class="flex items-center justify-between gap-2 px-2 py-2 rounded-xl bg-slate-50/60 border border-slate-100">
                        <div class="flex items-center gap-2 min-w-0">
                          <img [src]="providerLogo(entry)" class="w-4 h-4 opacity-80 shrink-0"
                            [title]="providerTitle(entry)" />
                          <span class="text-[11px] font-bold text-slate-600 truncate">{{ entry.name }}</span>
                        </div>
                        <div class="flex items-center gap-1 shrink-0">
                          <!-- Hide first: the panel renders above the modal and
                               would sit on top of what it just opened. -->
                          <button *ngIf="canShowRules(entry)" (click)="linksPanel.hide(); onShowRules(entry)"
                            [title]="'view_rules_label' | translate"
                            class="w-6 h-6 flex items-center justify-center rounded-lg text-slate-400 hover:text-primary hover:bg-primary/10 transition-all">
                            <i class="pi pi-eye text-[10px]"></i>
                          </button>
                          <button *ngIf="canEdit" (click)="linksPanel.hide(); onLinkDiagnosis(entry)"
                            [title]="'DTP_LINK_DIAGNOSIS' | translate"
                            class="w-6 h-6 flex items-center justify-center rounded-lg text-slate-400 hover:text-primary hover:bg-primary/10 transition-all">
                            <i class="pi pi-pencil text-[10px]"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </p-popover>
              </div>
              <button *ngIf="canEdit" (click)="$event.stopPropagation(); onEdit(item, 'diagnostic')"
                class="w-8 h-8 flex items-center justify-center rounded-xl text-slate-400 hover:text-primary hover:bg-primary/10 transition-all opacity-0 group-hover:opacity-100">
                <i class="pi pi-pencil text-xs"></i>
              </button>
            </div>
        </ng-template>

        <ng-container *ngIf="!loadingDiagnostics && diagnosticsView === 'list'">
          <ng-container *ngFor="let item of visibleDiagnostics">
            <ng-container *ngTemplateOutlet="diagnosticRow; context: { item: item }"></ng-container>
          </ng-container>
        </ng-container>

        <!-- Tree: family > subfamily > diagnosis. Rows that name a family but no
             subfamily hang directly off the family; rows with neither fall into
             "Others", which the builder sorts last. Rows run edge to edge so the
             dividers reach both sides; indentation is padding ON the row rather
             than a margin, which would pull the dividers in with it. -->
        <ng-container *ngIf="!loadingDiagnostics && diagnosticsView === 'tree'">
          <div *ngFor="let family of diagnosticTree">
            <button (click)="toggleGroup(family.key)"
              class="w-full px-4 py-3 flex items-center gap-2.5 bg-slate-50/70 hover:bg-slate-100/70 border-b border-slate-100 transition-colors text-left">
              <i class="pi text-[8px] text-slate-400 shrink-0"
                [ngClass]="isGroupOpen(family.key) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              <span class="text-[11px] font-black uppercase tracking-wider truncate"
                [ngClass]="family.isOthers ? 'text-slate-400' : 'text-slate-700'">{{ family.label }}</span>
              <span class="shrink-0 text-[10px] font-bold px-2 py-0.5 rounded-full bg-slate-100 text-slate-500">
                {{ family.count }}
              </span>
            </button>

            <ng-container *ngIf="isGroupOpen(family.key)">
              <div *ngFor="let sub of family.subfamilies">
                <button (click)="toggleGroup(sub.key)"
                  class="w-full pl-8 pr-4 py-2.5 flex items-center gap-2.5 hover:bg-slate-50/70 border-b border-slate-50 transition-colors text-left">
                  <i class="pi text-[8px] text-slate-400 shrink-0"
                    [ngClass]="isGroupOpen(sub.key) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                  <span class="text-[11px] font-bold text-slate-600 truncate">{{ sub.label }}</span>
                  <span class="shrink-0 text-[10px] font-bold px-2 py-0.5 rounded-full bg-slate-100 text-slate-500">
                    {{ sub.items.length }}
                  </span>
                </button>
                <ng-container *ngIf="isGroupOpen(sub.key)">
                  <ng-container *ngFor="let item of sub.items">
                    <ng-container
                      *ngTemplateOutlet="diagnosticRow; context: { item: item, tree: true, deep: true }"></ng-container>
                  </ng-container>
                </ng-container>
              </div>

              <ng-container *ngFor="let item of family.direct">
                <ng-container
                  *ngTemplateOutlet="diagnosticRow; context: { item: item, tree: true, deep: false }"></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </app-catalogue-pane>
    </div>

    <!-- Treatments Column -->
    <div [ngClass]="paneClass('treatments')">
      <app-catalogue-pane
        heading="treatments_label"
        icon="pi-list"
        [count]="visibleTreatments.length"
        [showCount]="!!selectedDiagnostic || treatmentsScope === 'all'"
        [dim]="!selectedDiagnostic && treatmentsScope !== 'all'"
        [loading]="loadingTreatments"
        [isEmpty]="visibleTreatments.length === 0"
        emptyIcon="pi-info-circle"
        [emptyMessage]="selectedDiagnostic || treatmentsScope === 'all' ? 'no_items_added' : 'select_diagnostic_first'"
        [showSearch]="true"
        [searchDisabled]="!selectedDiagnostic && treatmentsScope !== 'all'"
        [(search)]="treatmentSearch">

        <div paneActions class="w-full flex items-center gap-2">
          <!-- Browse the whole branch catalogue without first picking a diagnosis.
               Selecting a diagnosis switches straight back to its treatments. -->
          <app-button [label]="'DTP_ALL_TREATMENTS' | translate" icon="pi pi-list" size="small"
            [variant]="treatmentsScope === 'all' ? 'primary' : 'ghost'"
            (onClick)="showAllTreatments()"></app-button>
          <app-button *hasPermission="'Configurações:edit'" [label]="'add_existing_label' | translate"
            icon="pi pi-link" size="small" variant="ghost" (onClick)="onLinkTreatment()"
            [disabled]="!selectedDiagnostic"></app-button>
          <app-button *hasPermission="'Configurações:create'" [label]="'add_label' | translate" icon="pi pi-plus" size="small" (onClick)="onAdd('treatment')"
            [disabled]="!selectedDiagnostic"></app-button>
        </div>

        <ng-container *ngIf="!loadingTreatments">
          <ng-container *ngFor="let item of visibleTreatments">
            <div (click)="selectTreatment(item)"
              class="px-5 py-4 flex items-center justify-between cursor-pointer rounded-2xl transition-all duration-200 mb-1 group"
              [class.bg-primary/5]="selectedTreatment?.id === item.id"
              [class.border-primary/20]="selectedTreatment?.id === item.id"
              [class.border]="selectedTreatment?.id === item.id"
              [class.border-transparent]="selectedTreatment?.id !== item.id"
              [class.hover:bg-slate-50]="selectedTreatment?.id !== item.id">
              <div class="flex items-center gap-3">
                <div class="w-2 h-2 rounded-full transition-all" [class.bg-primary]="selectedTreatment?.id === item.id"
                  [class.bg-slate-200]="selectedTreatment?.id !== item.id"></div>
                <span class="text-sm font-bold" [class.text-primary]="selectedTreatment?.id === item.id"
                  [class.text-slate-700]="selectedTreatment?.id !== item.id">{{ item.name }}</span>
                <div *ngIf="item.is_System_Generated" class="flex items-center gap-1.5 ml-1">
                  <img [src]="providerLogo(item)" class="w-3.5 h-3.5 opacity-80"
                    [title]="providerTitle(item)" />
                  <i class="pi pi-lock text-[10px] text-slate-300" [title]="'system_generated' | translate"></i>
                  <button (click)="$event.stopPropagation(); onShowRules(item)"
                    class="w-6 h-6 flex items-center justify-center rounded-lg text-slate-400 hover:text-primary hover:bg-primary/10 transition-all">
                    <i class="pi pi-eye text-[10px]"></i>
                  </button>
                </div>
              </div>
              <button *ngIf="!item.is_System_Generated && canEdit" (click)="$event.stopPropagation(); onEdit(item, 'treatment')"
                class="w-8 h-8 flex items-center justify-center rounded-xl text-slate-400 hover:text-primary hover:bg-primary/10 transition-all opacity-0 group-hover:opacity-100">
                <i class="pi pi-pencil text-xs"></i>
              </button>
            </div>
          </ng-container>
        </ng-container>
      </app-catalogue-pane>
    </div>

    <!-- Procedures Column -->
    <div [ngClass]="paneClass('procedures')">
      <app-catalogue-pane
        heading="procedures_label"
        icon="pi-check-square"
        [count]="visibleProcedures.length"
        [showCount]="!!selectedTreatment"
        [dim]="!selectedTreatment"
        [loading]="loadingProcedures"
        [isEmpty]="visibleProcedures.length === 0"
        emptyIcon="pi-link"
        [emptyMessage]="selectedTreatment ? 'no_items_added' : 'select_treatment_first'"
        [showSearch]="true"
        [searchDisabled]="!selectedTreatment"
        [(search)]="procedureSearch">

        <app-button paneActions *hasPermission="'Configurações:create'" [label]="'add_existing_label' | translate" icon="pi pi-link" size="small" (onClick)="onAdd('procedure')"
          [disabled]="!selectedTreatment"></app-button>

        <div *ngIf="!loadingProcedures">
          <div *ngFor="let item of visibleProcedures"
            class="px-5 py-4 flex items-center justify-between rounded-2xl border border-transparent hover:border-slate-100 transition-all duration-200 mb-1 group hover:bg-slate-50/50">
            <div class="flex items-start gap-3">
              <div class="w-2 h-2 rounded-full bg-slate-200 mt-1.5 flex-shrink-0"></div>
              <div class="flex flex-col gap-0.5">
                <span class="text-sm font-bold text-slate-700 line-clamp-1">{{ item.procedure_name || item.description
                  }}</span>
                <div class="flex items-center gap-2 mt-0.5" *ngIf="item.isDefault || item.newAppointmentSuggestion">
                  <span *ngIf="item.isDefault"
                    class="px-1.5 py-0.5 rounded-md bg-indigo-50 text-indigo-600 text-[8px] font-black uppercase tracking-widest border border-indigo-100 shadow-sm">
                    {{ 'dtp_badge_default' | translate }}
                  </span>
                  <span *ngIf="item.newAppointmentSuggestion"
                    class="px-1.5 py-0.5 rounded-md bg-amber-50 text-amber-600 text-[8px] font-black uppercase tracking-widest border border-amber-100 shadow-sm">
                    {{ 'dtp_badge_appointment_suggestion' | translate }}
                  </span>
                </div>
              </div>
            </div>
            <p-menu #menu [model]="procedureMenuItems" [popup]="true" appendTo="body"></p-menu>
            <button *ngIf="canEdit || canDelete" (click)="$event.stopPropagation(); selectedItemForModal = item; menu.toggle($event)"
              class="w-8 h-8 flex items-center justify-center rounded-xl text-slate-300 hover:text-primary hover:bg-primary/5 transition-all opacity-0 group-hover:opacity-100">
              <i class="pi pi-ellipsis-v text-xs"></i>
            </button>
            <div *ngIf="item.is_System_Generated" class="flex items-center gap-1.5">
              <img [src]="providerLogo(item)" class="w-3.5 h-3.5 opacity-80"
                [title]="providerTitle(item)" />
              <i class="pi pi-lock text-[10px] text-slate-300"></i>
              <button *ngIf="canShowRules(item)" (click)="$event.stopPropagation(); onShowRules(item)"
                class="w-6 h-6 flex items-center justify-center rounded-lg text-slate-400 hover:text-primary hover:bg-primary/10 transition-all">
                <i class="pi pi-eye text-[10px]"></i>
              </button>
            </div>
          </div>
        </div>
      </app-catalogue-pane>
    </div>
  </div>

  <!-- AI MAPPING: point each provider entry at one of the clinic's own
       diagnoses. Provider entries carry no treatments of their own, so this
       link is what gives an imported finding a usable plan. -->
  <div *ngIf="view === 'mapping'"
    class="flex flex-col bg-white border border-slate-100 rounded-[2rem] overflow-hidden shadow-sm h-[720px]">
    <div class="bg-slate-50/50 px-6 py-5 border-b border-slate-100 flex flex-col gap-4">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <!-- Provider picker, only for providers this clinic actually has -->
        <div class="flex items-center gap-1 p-1 bg-white rounded-full border border-slate-200 shadow-sm">
          <button *ngIf="hasDioCreds" (click)="setMappingProvider('dio')"
            [class.bg-primary]="mappingProvider === 'dio'" [class.text-white]="mappingProvider === 'dio'"
            [class.text-slate-400]="mappingProvider !== 'dio'"
            class="px-4 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none">
            Dio
          </button>
          <button *ngIf="hasDiagnocatCreds" (click)="setMappingProvider('diagnocat')"
            [class.bg-primary]="mappingProvider === 'diagnocat'" [class.text-white]="mappingProvider === 'diagnocat'"
            [class.text-slate-400]="mappingProvider !== 'diagnocat'"
            class="px-4 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none">
            Diagnocat
          </button>
        </div>

        <div class="flex items-center gap-3">
          <div class="relative">
            <i class="pi pi-search absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-xs"></i>
            <input type="text" [(ngModel)]="mappingSearch" [placeholder]="'SEARCH' | translate"
              class="w-56 pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-xl text-xs focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all font-medium">
          </div>
          <div class="flex items-center gap-1 p-1 bg-white rounded-full border border-slate-200 shadow-sm">
            <button (click)="mappingFilter = 'all'"
              [class.bg-primary]="mappingFilter === 'all'" [class.text-white]="mappingFilter === 'all'"
              [class.text-slate-400]="mappingFilter !== 'all'"
              class="px-3 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none whitespace-nowrap">
              {{ 'ALL' | translate }}
            </button>
            <button (click)="mappingFilter = 'linked'"
              [class.bg-primary]="mappingFilter === 'linked'" [class.text-white]="mappingFilter === 'linked'"
              [class.text-slate-400]="mappingFilter !== 'linked'"
              class="px-3 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none whitespace-nowrap">
              {{ 'DTP_LINKED_ONLY' | translate }}
            </button>
            <button (click)="mappingFilter = 'unlinked'"
              [class.bg-amber-500]="mappingFilter === 'unlinked'" [class.text-white]="mappingFilter === 'unlinked'"
              [class.text-slate-400]="mappingFilter !== 'unlinked'"
              class="px-3 py-1.5 rounded-full text-[9px] font-black uppercase tracking-widest transition-all leading-none whitespace-nowrap">
              {{ 'DTP_UNLINKED_ONLY' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Progress: what a clinic is actually working through -->
      <div class="flex items-center gap-3">
        <div class="flex-1 h-1.5 bg-slate-200 rounded-full overflow-hidden">
          <div class="h-full bg-primary rounded-full transition-all duration-500"
            [style.width.%]="mappingPercent"></div>
        </div>
        <span class="text-[10px] font-black text-slate-500 whitespace-nowrap">
          {{ mappingLinkedCount }} / {{ mappingTotalCount }} {{ 'DTP_LINKED_LABEL' | translate }}
        </span>
      </div>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar p-3">
      <div *ngIf="mappingRows.length === 0"
        class="flex flex-col items-center justify-center py-20 text-slate-400 gap-4">
        <div class="w-16 h-16 rounded-[2rem] bg-slate-50 flex items-center justify-center">
          <i class="pi pi-check-circle text-2xl opacity-40"></i>
        </div>
        <span class="text-xs font-bold uppercase tracking-widest">
          {{ (mappingFilter === 'unlinked' ? 'DTP_ALL_LINKED' : 'no_items_added') | translate }}
        </span>
      </div>

      <div *ngFor="let item of mappingRows"
        class="px-5 py-3 flex items-center justify-between gap-4 rounded-2xl transition-all mb-1 group hover:bg-slate-50">
        <!-- Left: what the provider calls it -->
        <div class="flex items-center gap-3 min-w-0 flex-1">
          <img [src]="providerLogo(item)" class="w-5 h-5 opacity-80 shrink-0" [title]="providerTitle(item)" />
          <span class="text-sm font-bold text-slate-700 truncate">{{ item.name }}</span>
          <button *ngIf="canShowRules(item)" (click)="onShowRules(item)"
            [title]="'view_rules_label' | translate"
            class="w-6 h-6 shrink-0 flex items-center justify-center rounded-lg text-slate-300 hover:text-primary hover:bg-primary/10 transition-all opacity-0 group-hover:opacity-100">
            <i class="pi pi-eye text-[10px]"></i>
          </button>
        </div>

        <!-- Right: what the clinic calls it, or the gap -->
        <div class="flex items-center gap-2 shrink-0">
          <i class="pi pi-arrow-right text-[9px] text-slate-300"></i>
          <button *ngIf="canEdit" (click)="onLinkDiagnosis(item)"
            class="h-8 flex items-center gap-2 px-3 rounded-xl transition-all border text-[10px] font-black uppercase tracking-wider max-w-[240px]"
            [ngClass]="linkedMasterName(item)
              ? 'bg-primary/5 border-primary/20 text-primary hover:bg-primary/10'
              : 'bg-amber-50 border-amber-200 text-amber-600 hover:bg-amber-100'">
            <i class="pi text-[10px]" [ngClass]="linkedMasterName(item) ? 'pi-link' : 'pi-exclamation-circle'"></i>
            <span class="truncate">{{ linkedMasterName(item) || ('DTP_NOT_LINKED' | translate) }}</span>
          </button>
          <span *ngIf="!canEdit" class="text-[10px] font-black uppercase tracking-wider"
            [ngClass]="linkedMasterName(item) ? 'text-primary' : 'text-slate-300'">
            {{ linkedMasterName(item) || ('DTP_NOT_LINKED' | translate) }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div>
    <!-- Modals -->
    <app-dtp-edit-modal *ngIf="showEditModal" [type]="modalType === 'diagnostic' ? 'diagnostic' : 'treatment'"
      [item]="selectedItemForModal" [branchId]="branchId!"
      [linkedProviderNames]="modalType === 'diagnostic' && selectedItemForModal ? linkedProviderNames(selectedItemForModal.id) : []"
      [parentId]="modalType === 'treatment' ? selectedDiagnostic?.id : null" (close)="closeModals()"
      (saved)="onModalSaved()" (deleted)="onModalDeleted()"></app-dtp-edit-modal>

    <app-dtp-link-diagnosis-modal *ngIf="showLinkDiagnosisModal && diagnosticToLink"
      [providerDiagnostic]="diagnosticToLink" [branchId]="branchId!"
      [currentMasterId]="linkedMasterId(diagnosticToLink)" (close)="closeModals()"
      (saved)="onModalSaved()"></app-dtp-link-diagnosis-modal>

    <app-dtp-link-treatment-modal *ngIf="showLinkTreatmentModal" [diagnosticId]="selectedDiagnostic.id"
      [branchId]="branchId!" [excludedTreatmentIds]="excludedTreatmentIds" (close)="closeModals()"
      (saved)="onModalSaved()"></app-dtp-link-treatment-modal>

    <app-dtp-procedure-modal *ngIf="showProcedureModal" [treatmentId]="selectedTreatment.id" [branchId]="branchId!"
      [excludedProcedureIds]="excludedProcedureIds" (close)="closeModals()"
      (saved)="onModalSaved()"></app-dtp-procedure-modal>

    <app-dtp-delete-modal *ngIf="showDeleteModal" [type]="'procedure'" [item]="selectedItemForModal"
      [treatmentId]="selectedTreatment.id" (close)="closeModals()" (deleted)="onModalDeleted()"></app-dtp-delete-modal>

    <app-dtp-import-rules-modal *ngIf="showImportModal" (close)="onCloseImport()" (saved)="onImportSaved()">
    </app-dtp-import-rules-modal>

    <app-dtp-import-diagnostics-modal *ngIf="showImportDiagnosticsModal" [branchId]="branchId"
      (close)="onCloseImportDiagnostics()" (saved)="onDiagnosticsImported()">
    </app-dtp-import-diagnostics-modal>

    <app-dtp-procedure-settings-modal *ngIf="showProcedureSettingsModal" [procedure]="selectedItemForModal"
      (close)="showProcedureSettingsModal = false" (saved)="onModalSaved(); showProcedureSettingsModal = false">
    </app-dtp-procedure-settings-modal>

    <!-- Rules Modal -->
    <div *ngIf="showRulesModal" class="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
      <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm animate-fadeIn" (click)="closeRulesModal()"></div>

      <div
        class="bg-white w-full max-w-lg rounded-[2rem] shadow-2xl relative overflow-hidden animate-slideUp border border-slate-100">
        <!-- Minimalist Header -->
        <div class="px-8 py-6 border-b border-slate-100 flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
              <i class="pi" [ngClass]="isEditingRules ? 'pi-pencil' : 'pi-shield'"></i>
            </div>
            <div>
              <h3 class="text-lg font-bold text-slate-800">{{ (isEditingRules ? 'edit_rules_label' :
                'clinical_rules_label') | translate }}</h3>
              <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">
                {{ selectedRules?.label || (selectedItemForModal?.name) }}
              </p>
            </div>
          </div>
          <button (click)="closeRulesModal()"
            class="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-slate-50 transition-all text-slate-400">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Content - Simplified List -->
        <div class="max-h-[60vh] overflow-y-auto custom-scrollbar">
          <div *ngIf="!selectedRules" class="flex flex-col items-center justify-center py-20 text-slate-300 gap-4">
            <i class="pi pi-search text-3xl opacity-20"></i>
            <p class="text-xs font-bold uppercase tracking-widest">{{ 'no_rules_found' | translate }}</p>
          </div>

          <div *ngIf="selectedRules" class="divide-y divide-slate-50">
            <div *ngFor="let rule of clinicalRules"
              class="px-8 py-4 flex items-center justify-between hover:bg-slate-50/50 transition-colors group">

              <div class="flex items-center gap-4">
                <i class="pi text-xs text-slate-300 group-hover:text-primary transition-colors"
                  [ngClass]="rule.icon"></i>
                <div class="flex flex-col">
                  <span class="text-[11px] font-bold text-slate-600 uppercase tracking-wider">
                    {{ rule.label | translate }}
                  </span>

                </div>
              </div>

              <div class="flex items-center justify-end min-w-[120px]">
                <ng-container *ngIf="isEditingRules; else staticView">
                  <!-- Select -->
                  <p-select *ngIf="rule.options" [(ngModel)]="editingRulesData[rule.key]" [options]="rule.options"
                    optionLabel="label" optionValue="value" [style]="{'width': '160px'}" appendTo="body">
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                      <div class="flex items-center gap-2">
                        <div *ngIf="rule.key === 'color_rule'"
                          [style.background-color]="getColorCode(selectedOption.value)"
                          class="w-2.5 h-2.5 rounded-full border border-slate-200"></div>
                        <span class="text-[11px] font-bold">{{ selectedOption.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-option>
                      <div class="flex items-center gap-2">
                        <div *ngIf="rule.key === 'color_rule'" [style.background-color]="getColorCode(option.value)"
                          class="w-2.5 h-2.5 rounded-full border border-slate-200"></div>
                        <span class="text-[11px] font-bold">{{ option.label }}</span>
                      </div>
                    </ng-template>
                  </p-select>

                  <!-- Boolean -->
                  <p-checkbox *ngIf="rule.isBool" [(ngModel)]="editingRulesData[rule.key]" [binary]="true"></p-checkbox>

                  <!-- Text -->
                  <input *ngIf="!rule.options && !rule.isBool" pInputText [(ngModel)]="editingRulesData[rule.key]"
                    class="custom-input w-[160px] text-right" />
                </ng-container>

                <ng-template #staticView>
                  <div class="flex items-center gap-2">
                    <span *ngIf="rule.isBool"
                      class="px-2.5 py-1 rounded-lg text-[9px] font-black uppercase tracking-wider"
                      [ngClass]="selectedRules[rule.key] ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-400'">
                      {{ (selectedRules[rule.key] ? 'status_active' : 'status_inactive') | translate }}
                    </span>
                    <span *ngIf="!rule.isBool"
                      class="text-[11px] font-bold text-slate-700 bg-white px-3 py-1.5 rounded-xl border border-slate-100 shadow-sm flex items-center gap-2">
                      <div *ngIf="rule.key === 'color_rule'"
                        [style.background-color]="getColorCode(selectedRules[rule.key])"
                        class="w-2.5 h-2.5 rounded-full border border-slate-200"></div>
                      {{ formatValue(selectedRules[rule.key]) }}
                    </span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="p-6 bg-slate-50/50 border-t border-slate-100 flex justify-end gap-3">
          <ng-container *ngIf="!isEditingRules">
            <app-button *hasPermission="'Configurações:edit'" [label]="'edit_rules_label' | translate" icon="pi pi-pencil" (onClick)="onEditRules()"
              size="small"></app-button>
            <app-button [label]="'close_label' | translate" (onClick)="closeRulesModal()" variant="ghost"
              size="small"></app-button>
          </ng-container>

          <ng-container *ngIf="isEditingRules">
            <app-button [label]="'common_save' | translate" icon="pi pi-check" (onClick)="saveRules()"
              size="small"></app-button>
            <app-button [label]="'button_cancel' | translate" (onClick)="cancelEditRules()" variant="ghost"
              size="small"></app-button>
          </ng-container>
        </div>
      </div>
    </div>